<img src="/assets/images/v2/jackpot/open-chest/chest.svg"
        height="30"
        class="chest-wagered-img">
<div class="chest-wagered-progress-wrap">
    <div class="chest-wagered-progress" [style.width]="progress + '%'"></div>
</div>
<div class="chest-dropdown-wrap" [@dropdown]="'show'" *ngIf="showDropdown">
    <div class="hovering-part"></div>
    <h6 class="next-chest-in-heading">Next chest in: {{ remainingWager | currency: 'USD' }}</h6>
    <div class="chest-wagered-progress-wrap big-wrap">
        <div class="chest-wagered-progress"  [style.width]="progress + '%'"></div>
    </div>
    <div class="chest-sideflex">
        <div class="chest-left-wrap">
            <img src="/assets/images/v2/jackpot/baltymu-saltinis.png"
                 height="150" alt="" class="chest-glow">
            <img
                    src="/assets/images/v2/jackpot/open-chest/chest.svg"
                    height="45"
                    class="chest-wagered-img">
        </div>
        <div class="chest-right-wrap">
            <h6 class="heading-5">Jackpot chest</h6>
            <p class="small-paragraph">Contains 1 to 10 jackpot keys</p>
        </div>
    </div>
    <div class="chest-cost-wrap">
        <img src="/assets/images/v2/jackpot/wager-amount.svg" height="40" alt="" class="wager-icon">
        <div>Wagered: {{ wagered | currency: 'USD' }}</div>
    </div>
    <div class="chest-cost-wrap">
        <img
                src="/assets/images/v2/jackpot/open-chest/chest.svg"
                width="30" class="chest-small-icon">
        <div>You have {{ chests }} chests</div>
    </div>
    <a [routerLink]="['/', { outlets: { modal: 'open-chest' } } ]" *ngIf="chests">
        <app-form-button class="primary full-width" *ngIf="chests">Open chest</app-form-button>
    </a>
    <a routerLink="/jackpot" class="link">About the promotion <i class="fa fa-star"></i></a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/chest-wager/chest-wager.template.html